// src/config/api.ts

/**
 * API Configuration with Environment Detection
 */

// const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
// const isPort3000 = window.location.port === '3000';

// זיהוי סביבה
const getApiBaseUrl = (): string => {
  // אם אנחנו ב-localhost (בכל מקרה) - השתמש ב-port 3002
  if (isLocalhost) {
    return 'http://localhost:3002';
  }

  // בפרודקשן אמיתי - השתמש באותו origin (ללא port)
  const currentOrigin = window.location.origin;
  return currentOrigin;
};

export const API_BASE_URL = getApiBaseUrl();

// Debug info לפיתוח
// console.log('Environment Detection:');
// console.log('- NODE_ENV:', process.env.NODE_ENV);
// console.log('- hostname:', window.location.hostname);
// console.log('- port:', window.location.port);
// console.log('- origin:', window.location.origin);
// console.log('- isDevelopment:', isDevelopment);
// console.log('- isLocalhost:', isLocalhost);
// console.log('- isPort3000:', isPort3000);
// console.log('- API_BASE_URL:', API_BASE_URL);

export default API_BASE_URL;